/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { ErrorHandler } from '../core/error.service';
import { Observable } from 'rxjs';
import { SocketConnection } from '../../sockets/socket.connections';

/**
 * Api services for the `PenaltyCharge` model (late-payment penalties on the
 * existing invoicing system). Hand-written (not lb-sdk generated) - only the
 * custom endpoints are exposed.
 */
@Injectable()
export class PenaltyChargeApi extends BaseLoopBackApi {
    constructor(
        @Inject(HttpClient) protected http: HttpClient,
        @Inject(SocketConnection) protected connection: SocketConnection,
        @Inject(SDKModels) protected models: SDKModels,
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
    ) {
        super(http, connection, models, auth, errorHandler);
    }

    /** GET /PenaltyCharges/config - every property with its penalty configuration. */
    public getConfig(customHeaders?: Function): Observable<any> {
        const _method = 'GET';
        const _url =
            LoopBackConfig.getPath() + '/' + LoopBackConfig.getApiVersion() + '/PenaltyCharges/config';
        return this.request(_method, _url, {}, {}, {}, null, customHeaders);
    }

    /** POST /PenaltyCharges/config - set one property's penalty configuration. */
    public setConfig(data: any = {}, customHeaders?: Function): Observable<any> {
        const _method = 'POST';
        const _url =
            LoopBackConfig.getPath() + '/' + LoopBackConfig.getApiVersion() + '/PenaltyCharges/config';
        return this.request(_method, _url, {}, {}, { data: data }, null, customHeaders);
    }

    /** GET /PenaltyCharges/offenders - preview of overdue rent invoices eligible for a penalty (read-only). */
    public listOffenders(propertyId?: any, customHeaders?: Function): Observable<any> {
        const _method = 'GET';
        const _url =
            LoopBackConfig.getPath() + '/' + LoopBackConfig.getApiVersion() + '/PenaltyCharges/offenders';
        const _urlParams: any = {};
        if (typeof propertyId !== 'undefined' && propertyId !== null) _urlParams.propertyId = propertyId;
        return this.request(_method, _url, {}, _urlParams, {}, null, customHeaders);
    }

    /** GET /PenaltyCharges/export - the offenders preview as a downloadable Excel file. */
    public exportOffenders(propertyId?: any, customHeaders?: Function): Observable<any> {
        const _method = 'GET';
        const _url =
            LoopBackConfig.getPath() + '/' + LoopBackConfig.getApiVersion() + '/PenaltyCharges/export';
        const _urlParams: any = {};
        if (typeof propertyId !== 'undefined' && propertyId !== null) _urlParams.propertyId = propertyId;
        return this.request(_method, _url, {}, _urlParams, {}, null, customHeaders);
    }

    /** POST /PenaltyCharges/apply - charge the penalty for the given overdue invoices. */
    public apply(data: any = {}, customHeaders?: Function): Observable<any> {
        const _method = 'POST';
        const _url =
            LoopBackConfig.getPath() + '/' + LoopBackConfig.getApiVersion() + '/PenaltyCharges/apply';
        return this.request(_method, _url, {}, {}, { data: data }, null, customHeaders);
    }

    public getModelName() {
        return 'PenaltyCharge';
    }
}
